import { TSP } from '@/types';
import React, { HTMLAttributes } from 'react';
import { BadgeDisplay } from './BadgeDisplay';
import { useFocusTSP } from '../hooks/useFocusTSP';

type TSPLike = Partial<TSP>;

export type TSPBadgeProps = {
  tsp: TSPLike;
  extraContent?: React.ReactNode | React.ReactNode[];
  style?: React.CSSProperties;
  className?: string;
  showTspName?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const TSPBadge = ({
  tsp,
  extraContent = '',
  style = {},
  className,
  ...props
}: TSPBadgeProps) => {
  const focusTSP = useFocusTSP();
  if (!tsp) {
    return null;
  }
  return (
    <BadgeDisplay
      style={style}
      role="button"
      className={className}
      {...props}
      onClick={(evt) => {
        focusTSP(tsp.id);
        props.onClick?.(evt);
      }}
    >
      {tsp.name}
      <br />
      {extraContent}
    </BadgeDisplay>
  );
};
